function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { forwardRef, useRef, useImperativeHandle } from 'react';
import { classNames, getExtraAttrs, extend } from '../shared/utils.js';
import { colorClasses } from '../shared/mixins.js';
import { useTheme } from '../shared/use-theme.js';


const Preloader = /*#__PURE__*/forwardRef((props, ref) => {
  const theme = useTheme();
  const {
    className,
    id,
    style,
    size
  } = props;
  const extraAttrs = getExtraAttrs(props);
  const elRef = useRef(null);
  useImperativeHandle(ref, () => ({
    el: elRef.current
  }));
  const preloaderStyle = {};
  let sizeComputed = size;
  if (sizeComputed && typeof sizeComputed === 'string' && sizeComputed.indexOf('px') >= 0) {
    sizeComputed = sizeComputed.replace('px', '');
  }
  if (sizeComputed) {
    preloaderStyle.width = `${sizeComputed}px`;
    preloaderStyle.height = `${sizeComputed}px`;
    preloaderStyle['--f7-preloader-size'] = `${sizeComputed}px`;
  }
  if (style) extend(preloaderStyle, style || {});
  let innerEl;
  if (theme && theme.md) {
    innerEl = /*#__PURE__*/React.createElement("span", {
      className: "preloader-inner"
    }, /*#__PURE__*/React.createElement("svg", {
      viewBox: "0 0 36 36"
    }, /*#__PURE__*/React.createElement("circle", {
      cx: "18",
      cy: "18",
      r: "16"
    })));
  } else if (theme && theme.ios) {
    innerEl = /*#__PURE__*/React.createElement("span", {
      className: "preloader-inner"
    }, /*#__PURE__*/React.createElement("span", {
      className: "preloader-inner-line"
    }), /*#__PURE__*/React.createElement("span", {
      className: "preloader-inner-line"
    }), /*#__PURE__*/React.createElement("span", {
      className: "preloader-inner-line"
    }), /*#__PURE__*/React.createElement("span", {
      className: "preloader-inner-line"
    }), /*#__PURE__*/React.createElement("span", {
      className: "preloader-inner-line"
    }), /*#__PURE__*/React.createElement("span", {
      className: "preloader-inner-line"
    }), /*#__PURE__*/React.createElement("span", {
      className: "preloader-inner-line"
    }), /*#__PURE__*/React.createElement("span", {
      className: "preloader-inner-line"
    }));
  } else if (!theme) {
    innerEl = /*#__PURE__*/React.createElement("span", {
      className: "preloader-inner"
    });
  }
  const classes = classNames(className, {
    preloader: true
  }, colorClasses(props));
  return /*#__PURE__*/React.createElement("span", _extends({
    id: id,
    style: preloaderStyle,
    className: classes,
    ref: elRef
  }, extraAttrs), innerEl);
});
Preloader.displayName = 'f7-preloader';
export default Preloader;